export default {
  item: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/texts/state.js